export const MONITORED_AIRLINES = ['AA', 'DL', 'UA'];

export const SUPPORTED_AIRLINE_OPTIONS = [
  { code: 'AA', name: 'American Airlines' },
  { code: 'DL', name: 'Delta Air Lines' },
  { code: 'UA', name: 'United Airlines' },
] as const;

export const AIRLINE_NAMES: Record<string, string> = {
  AA: 'American Airlines', DL: 'Delta Air Lines', UA: 'United Airlines',
  WN: 'Southwest', B6: 'JetBlue', AS: 'Alaska Airlines',
  NK: 'Spirit', F9: 'Frontier', HA: 'Hawaiian Airlines',
  AI: 'Air India', BA: 'British Airways', EK: 'Emirates',
  QR: 'Qatar Airways', SQ: 'Singapore Airlines', LH: 'Lufthansa',
  AF: 'Air France', KL: 'KLM', CX: 'Cathay Pacific',
  NH: 'ANA', JL: 'Japan Airlines', QF: 'Qantas',
  AC: 'Air Canada', TK: 'Turkish Airlines', EY: 'Etihad',
  AM: 'Aeromexico', CM: 'Copa Airlines', AV: 'Avianca', LA: 'LATAM',
};

export function getAirlineName(code: string): string {
  return AIRLINE_NAMES[code] || code;
}

// Keep in sync with supabase/functions/_shared/formatters.ts getAirlineCreditTerm
const AIRLINE_CREDIT_TERMS: Record<string, string> = {
  DL: 'Delta eCredit',
  UA: 'United travel credit',
  AA: 'American Airlines trip credit',
};

export function getAirlineCreditTerm(code: string): string {
  return AIRLINE_CREDIT_TERMS[code] || 'airline travel credit';
}
